import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable react/prefer-es6-class */
const DefaultDecorators = [
  {
    /* eslint-disable react/prefer-es6-class */
    component: class extends React.Component {
      static displayName = 'PreviousButton';

      static propTypes = {
        currentSlide: PropTypes.number,
        previousSlide: PropTypes.func,
        wrapAround: PropTypes.bool,
      };

      getButtonStyles = disabled => {
        return {
          background: 'rgba(0,0,0,0.4)',
          border: 0,
          color: 'white',
          opacity: disabled ? 0.3 : 1,
          outline: 0,
          padding: 10,
        };
      };

      handleClick = e => {
        e.preventDefault();
        this.props.previousSlide();
      };

      render() {
        return (
          <button
            onClick={this.handleClick}
            style={this.getButtonStyles(this.props.currentSlide === 0 && !this.props.wrapAround)}
          >
            PREV
          </button>
        );
      }
    },

    position: 'CenterLeft',
  },
  {
    /* eslint-disable react/prefer-es6-class */
    component: class extends React.Component {
      static displayName = 'NextButton';

      static propTypes = {
        currentSlide: PropTypes.number,
        nextSlide: PropTypes.func,
        slideCount: PropTypes.number,
        slidesToScroll: PropTypes.number,
        wrapAround: PropTypes.bool,
      };

      getButtonStyles = disabled => {
        return {
          background: 'rgba(0,0,0,0.4)',
          border: 0,
          color: 'white',
          opacity: disabled ? 0.3 : 1,
          outline: 0,
          padding: 10,
        };
      };

      handleClick = e => {
        e.preventDefault();
        this.props.nextSlide();
      };

      render() {
        return (
          <button
            style={this.getButtonStyles(
              this.props.currentSlide + this.props.slidesToScroll >= this.props.slideCount && !this.props.wrapAround,
            )}
            onClick={this.handleClick}
          >
            NEXT
          </button>
        );
      }
    },

    position: 'CenterRight',
  },
  {
    /* eslint-disable react/prefer-es6-class */
    component: class extends React.Component {
      static displayName = 'ZoomButton';

      static propTypes = {
        openPhotoSwipe: PropTypes.func,
        s3BasePath: PropTypes.string,
      };

      getDivStyles = disabled => {
        return {
          opacity: disabled ? 0.3 : 1,
          outline: 0,
          padding: 10,
        };
      };

      getImgStyles = disabled => {
        return {
          height: 30,
          width: 30,
        };
      };

      render() {
        return (
          <div onClick={this.props.openPhotoSwipe} style={this.getDivStyles()}>
            <img src={`${this.props.s3BasePath}mkt/icon/zoom.png`} style={this.getImgStyles()} />
          </div>
        );
      }
    },

    position: 'BottomRightZoom',
  },
  {
    /* eslint-disable react/prefer-es6-class */
    component: class extends React.Component {
      static displayName = 'SlideIndicators';

      static propTypes = {
        currentSlide: PropTypes.number,
        goToSlide: PropTypes.func,
        slideCount: PropTypes.number,
        slidesToScroll: PropTypes.number,
      };

      getButtonStyles = active => {
        return {
          background: 'transparent',
          border: 0,
          color: 'black',
          fontSize: 24,
          opacity: active ? 1 : 0.5,
          outline: 0,
          padding: 2,
        };
      };

      getIndexes = (count, inc) => {
        const arr = [];
        for (let i = 0; i < count; i += inc) {
          arr.push(i);
        }
        return arr;
      };

      getListItemStyles = () => {
        return {
          display: 'inline-block',
          listStyleType: 'none',
        };
      };

      getListStyles = () => {
        return {
          margin: 0,
          padding: 0,
          position: 'relative',
          top: -10,
        };
      };

      render() {
        const indexes = this.getIndexes(this.props.slideCount, this.props.slidesToScroll);
        return (
          <ul style={this.getListStyles()}>
            {indexes.map(index => {
              return (
                <li style={this.getListItemStyles()} key={`slide-indicator-${index}`}>
                  <button
                    onClick={this.props.goToSlide.bind(null, index)}
                    style={this.getButtonStyles(this.props.currentSlide === index)}
                  >
                    &bull;
                  </button>
                </li>
              );
            })}
          </ul>
        );
      }
    },

    position: 'BottomCenter',
  },
];

export default DefaultDecorators;
